import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormServices } from 'src/app/services/form-services.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-descripcion-product',
  templateUrl: './descripcion-product.component.html',
  styleUrls: ['./descripcion-product.component.scss'],
})
export class DescripcionProductComponent implements OnInit {
  @Output() segment = new EventEmitter();
  @Input() savedForm = undefined;
  @Input() set data(value) {
    if (value) {
      this.fieldForms = value;
    }
  }
  @Input() route = undefined;
  @Input() set uri(value) {
    if (value) {
      this.fieldForms = undefined;
      this.getForm(value);
    }
  }

  @Input() fullWidth = undefined;
  @Input() showButton = undefined;
  @Input() id = undefined;
  @Output() emitFormValue = new EventEmitter();
  @Output() clearForm = new EventEmitter();
  @Output() loadedForm = new EventEmitter();

  public fieldForms = undefined;
  public domainId = environment.domainId;
  constructor(private formSv: FormServices) {}

  ngOnInit() {}

  clearInput() {
    this.clearForm.emit();
  }

  async getForm(uri) {
    try {
      if (!this.fieldForms) {
        const res = await this.formSv.getForm(uri, this.domainId);
        this.fieldForms = res;
        if (!res?.length) {
          this.segment.emit(this.route);
        }
        this.loadedForm.emit();
      }
    } catch (err) {
      console.error(err);
    }
  }

  async sendInfo(ev: FormData) {
    try {
      this.emitFormValue.emit(ev);
    } catch (err) {
      console.error(err);
    }
  }
}
